import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { useForm, Controller, ErrorMessage } from 'react-hook-form';
import Form from 'deltoid/core/Form';
import ErrorWrapper from '@components/BaseComponents/ErrorWrapper';

import { Body, Small } from "deltoid/core/Blocks/Typography";

import {
  ifscActions, ifscSelectors,
  dialogActions,
} from '@store/ducks';


const SearchIFSC = ({
  fetchBankNames,
  bankNames,
  fetchBankStates,
  states,
  fetchBankCities,
  cities,
  fetchBranches,
  branches,
  submitSearchIFSC,
  closeDialog,
  resetSearchForm
}) => {
  useEffect(() => {
    resetSearchForm();
    fetchBankNames();
  }, [])
  const {
    control,
    errors,
    handleSubmit,
    setValue,
    getValues,
  } = useForm();

  const onSubmit = formData => {
    submitSearchIFSC(formData.branch.value);
    closeDialog();
  }

  const resetDependentFields = fieldNames => fieldNames.forEach(name => setValue(name, null));

  return (
    <>
      <div className='co-header pl-4 pr-4 pt-4 pb-2 border-bottom'>
        <Body className='mb-1' variant='bold'>Search IFSC code</Body>
        <Small>
          IFSC code can be found on the cheque and passbook provided by the bank. 
          Or enter details below to find the correct IFSC code.
        </Small>
      </div>
      <form className="pt-2" onSubmit={handleSubmit(onSubmit)} data-testid='ifsc-search-form'>
        <Form.Group className="pl-4 pr-4">
          <Form.Label htmlFor='bankName'>Bank name</Form.Label>
          <Controller
            as={Form.Select}
            name='bankName'
            inputId='bankName'
            control={control}
            rules={{ required: "Bank name can not be empty" }}
            placeholder="Select your Bank Name"
            options={bankNames.map(bankName => ({ label: bankName, value: bankName }))}
            onChange={([v]) => {
              fetchBankStates(v.value);
              resetDependentFields(['state', 'city', 'branch']);
              return v;
            }}
          />
          <ErrorWrapper errors={errors} fieldName='bankName' data-testid='ifsc-search-bankName-error'/>
        </Form.Group>
        <Form.Group className="pl-4 pr-4">
          <Form.Label htmlFor='state'>Bank State</Form.Label>
          <Controller
            as={Form.Select}
            name='state'
            inputId='state'
            control={control}
            rules={{ required: "State can not be empty" }}
            placeholder="Select your State"
            options={states.map(state => ({ label: state, value: state }))}
            onChange={([v]) => {
              fetchBankCities(getValues('bankName').value, v.value)
              resetDependentFields(['city', 'branch']);
              return v;
            }}
          />
          <ErrorWrapper errors={errors} fieldName='state' data-testid='ifsc-search-state-error'/>
        </Form.Group>
        <Form.Group className="pl-4 pr-4">
          <Form.Label htmlFor='city'>Branch City</Form.Label>
          <Controller
            as={Form.Select}
            name='city'
            inputId='city'
            control={control}
            rules={{ required: "City can not be empty" }}
            placeholder="Select your City"
            options={cities.map(city => ({ label: city, value: city }))}
            onChange={([v]) => {
              fetchBranches(getValues('bankName').value, getValues('state').value, v.value);
              resetDependentFields(['branch']);
              return v;
            }}
          />
          <ErrorWrapper errors={errors} fieldName='city' data-testid='ifsc-search-city-error'/>
        </Form.Group>
        <Form.Group className="pl-4 pr-4">
          <Form.Label htmlFor='branch'>Branch</Form.Label>
          <Controller
            as={Form.Select}
            name='branch'
            inputId='branch'
            control={control}
            rules={{ required: "Branch can not be empty" }}
            placeholder="Select your Branch"
            options={branches.map(detail => (
              { label: detail.branch_name, value: detail }
            ))}
            onChange={([v]) => {
              // setValue('district', null)
              return v;
            }}
          />
          <ErrorWrapper errors={errors} fieldName='branch' data-testid='ifsc-search-branch-error'/>
        </Form.Group>
        <div className="d-flex bg-light pl-4 pr-4 pt-3 pb-3 flex-row-reverse">
          <Form.Button type="button" onClick={handleSubmit(onSubmit)}>
            Submit
          </Form.Button>
          <Form.Button type='button' onClick={closeDialog} className='bg-white border text-dark mr-3'>
            Cancel
          </Form.Button>
        </div>
      </form>
    </>
  )
};

const mapStateToProps = state => ({
  bankNames: ifscSelectors.getBankNames(state),
  states: ifscSelectors.getStates(state),
  cities: ifscSelectors.getCities(state),
  branches: ifscSelectors.getBranches(state),
});

const mapDispatchToProps = dispatch => ({
  fetchBankNames: () => dispatch(ifscActions.fetchBankNames()),
  fetchBankStates: bankName => dispatch(ifscActions.fetchBankStates(bankName)),
  fetchBankCities: (bankName, state) => dispatch(ifscActions.fetchBankCities(bankName, state)),
  fetchBranches: (bankName, state, city) =>
    dispatch(ifscActions.fetchBranches(bankName, state, city)),
  submitSearchIFSC: branchDetails => dispatch(ifscActions.submitSearchIFSC(branchDetails)),
  closeDialog: () => dispatch(dialogActions.close()),
  resetSearchForm: () => dispatch(ifscActions.resetSearchForm()),
});

export default connect(mapStateToProps, mapDispatchToProps)(SearchIFSC);